import React, { useEffect, useRef } from "react";
import ReactMarkdown from "react-markdown";
import styles from "./Library.module.css";

export default function ActivityModal({
  open,
  onClose,
  activity = {},
  onAddToPlan,
}) {
  const overlayRef = useRef(null);
  const closeRef = useRef(null);

  useEffect(() => {
    if (!open) return;

    closeRef.current?.focus();

    function onKey(e) {
      if (e.key === "Escape") onClose();
    }
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className={styles.modalOverlay}
      ref={overlayRef}
      onMouseDown={(e) => {
        if (e.target === overlayRef.current) onClose();
      }}
      role="dialog"
      aria-modal="true"
      aria-label={activity.title || "Detalhes da atividade"}
    >
      <div className={styles.modalCard} role="document">
        <div className={styles.modalHeaderClean}>
          <button
            ref={closeRef}
            aria-label="Fechar"
            className={styles.modalClose}
            onClick={onClose}
          >
            ✕
          </button>
        </div>

        <div className={styles.modalBody}>
          <h2 className={styles.modalTitle}>{activity.title || "Atividade"}</h2>
          <p className={styles.modalAxis}>
            {(activity.axis || "").toUpperCase()}
          </p>

          {activity.url && (
            <div className={styles.modalNotice}>
              <strong>Link:</strong>{" "}
              <a href={activity.url} target="_blank" rel="noreferrer">
                Abrir recurso
              </a>
            </div>
          )}

          <div className={styles.modalDescription}>
            {activity.content ? (
              <ReactMarkdown>{activity.content}</ReactMarkdown>
            ) : (
              <p className={styles.empty}>Sem descrição adicional.</p>
            )}
          </div>

          {/* Seleção de axis e dia */}
          {/* <div className={styles.modalActions}>
            <div>
              <label className={styles.smallLabel}>Axis</label>
              <select
                id="modal-axis-select"
                defaultValue={activity.axis || "mind"}
                className={styles.smallSelect}
              >
                <option value="mind">Mind</option>
                <option value="move">Move</option>
                <option value="nutri">Nutri</option>
                <option value="values">Values</option>
              </select>
            </div>

            <div>
              <label className={styles.smallLabel}>Dia</label>
              <select
                id="modal-day-select"
                defaultValue="monday"
                className={styles.smallSelect}
              >
                <option value="sunday">Domingo</option>
                <option value="monday">Segunda</option>
                <option value="tuesday">Terça</option>
                <option value="wednesday">Quarta</option>
                <option value="thursday">Quinta</option>
                <option value="friday">Sexta</option>
                <option value="saturday">Sábado</option>
              </select>
            </div>

            <div style={{ display: "flex", alignItems: "flex-end", gap: 8 }}>
              <button
                className="defaultButton"
                onClick={() => {
                  const axisChoice =
                    document.getElementById("modal-axis-select").value;
                  const dayChoice =
                    document.getElementById("modal-day-select").value;
                  if (onAddToPlan) onAddToPlan(activity, axisChoice, dayChoice);
                  onClose();
                }}
              >
                Adicionar ao plano
              </button>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
}
